module.exports = __webpack_public_path__ + "static/gallery-import-d69de9ef4e74c79e5404d8b02d37d21e.png";